/** @format */

import React, { useState } from "react";
import CustomModal from "../../core/modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import EditIcon from "@mui/icons-material/Edit";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Avatar, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomButtonComponent from "../../core/custom-button";
const ActionIcons = ({
  id,
  Code,
  Description,
  type,
  loadData,
  name,
  email,
  filters,
}) => {
  const [edit, setEdit] = useState(false);
  const [del, setDel] = useState(false);
  const [code, setCode] = useState(Code);
  const [description, setDescription] = useState(Description);
  const [editName, setEditName] = useState(name);
  const [editEmail, setEditEmail] = useState(email);
  const editHandler = () => {
    setEdit(true);
    setCode(Code);
    setDescription(Description);
  };
  const deleteHandler = () => {
    setDel(true);
  };
  const addCodeHandler = (event) => {
    setCode(event.target.value);
  };
  const addDescriptionHandler = (event) => {
    setDescription(event.target.value);
  };
  const editNameHandler = (event) => {
    setEditName(event.target.value);
  };
  const editEmailHandler = (event) => {
    setEditEmail(event.target.value);
  };
  const payload = {
    type: type,
    code: code,
    description: description,
  };
  const serviceEngPayload = {
    name: editName,
    email: editEmail,
  };
  //Edit data in Codes
  const editDataHandler = () => {
    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}/v1/simpcare/codes/${id}`, payload)
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          loadData(filters);
          setEdit(false);
        }
      })
      .catch((err) => console.error(err));
  };
  //Delete data in Codes
  const deleteDataHandler = () => {
    payload.active = false;
    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}/v1/simpcare/codes/${id}`, payload)
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          loadData(filters);
          setDel(false);
        }
      })
      .catch((err) => console.error(err));
  };
  //Edit Data in ServiceEngineers
  const editServiceEngHandler = () => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}/v1/simpcare/users/${id}`,
      serviceEngPayload
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          loadData(filters);
          setEdit(false);
        }
      })
      .catch((err) => console.error(err));
  };
  //Delete Data in ServiceEngineers
  const deleteServiceEngHandler = () => {
    invokeApi(HTTP_METHODS.DELETE, `${HOSTNAME}/v1/simpcare/users/${id}`)
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          loadData(filters);
          setDel(false);
        }
      })
      .catch((err) => console.error(err));
  };
  //Delete emailId in mailing List
  const deleteMailHandler = (id) => {
    invokeApi(
      HTTP_METHODS.DELETE,
      `${HOSTNAME}${REST_URLS.MAILING_LIST}/delete-email/${id}`
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          loadData(filters);
        }
      })
      .catch((err) => console.error(err));
  };
  let closeEditModal = () => {
    setEdit(false);
  };
  let CloseDeleteModal = () => {
    setDel(false);
  };
  const confirmDelete = () => {
    if (type === "SERVICE_ENGINEER") {
      deleteServiceEngHandler();
    } else if (type === "mailing list") {
      deleteMailHandler(id);
    } else {
      deleteDataHandler();
    }
    setDel(false);
  };
  return (
    <div>
      <Stack direction="row" spacing={3}>
        {type !== "mailing list" && (
          <IconButton sx={{ p: 0 }} onClick={editHandler}>
            <EditIcon color="primary" />
          </IconButton>
        )}

        {type !== "part" && (
          <IconButton onClick={deleteHandler} id="delete" sx={{ p: 0 }}>
            <DeleteIcon color="error" />
          </IconButton>
        )}
      </Stack>
      {edit && type !== "SERVICE_ENGINEER" && type !== "mailing list" && (
        <CustomModal title="Edit Code" onClose={closeEditModal}>
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            {type !== "part" && (
              <TextField
                fullWidth
                id="code"
                label="Code"
                sx={{ m: 1 }}
                onChange={addCodeHandler}
                value={code}
                size="small"
              />
            )}
            <TextField
              fullWidth
              id="description"
              label="Description"
              multiline
              sx={{ m: 1 }}
              rows={4}
              onChange={addDescriptionHandler}
              value={description}
              size="small"
            />
            <Stack direction="row" spacing={2} sx={{ m: 1 }}>
              <Button
                variant="outlined"
                color="error"
                fullWidth
                onClick={() => {
                  setEdit(false);
                }}
              >
                Cancel
              </Button>
              <CustomButtonComponent
                variant="contained"
                color="primary"
                fullWidth
                onClick={editDataHandler}
              >
                Save
              </CustomButtonComponent>
            </Stack>
          </Box>
        </CustomModal>
      )}
      {edit && type === "SERVICE_ENGINEER" && (
        <CustomModal title="Edit Service Engineer" onClose={closeEditModal}>
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            <TextField
              fullWidth
              id="name"
              label="Name"
              multiline
              sx={{ m: 1 }}
              onChange={editNameHandler}
              value={editName}
              size="small"
            />
            <TextField
              fullWidth
              id="email"
              label="Email"
              sx={{ m: 1 }}
              onChange={editEmailHandler}
              value={editEmail}
              type="email"
              size="small"
            />
            <Stack direction="row" spacing={2} sx={{ m: 1 }}>
              <CustomButtonComponent
                variant="outlined"
                color="error"
                fullWidth
                onClick={() => {
                  setEdit(false);
                }}
              >
                Cancel
              </CustomButtonComponent>
              <CustomButtonComponent
                variant="contained"
                color="primary"
                fullWidth
                onClick={editServiceEngHandler}
              >
                Save
              </CustomButtonComponent>
            </Stack>
          </Box>
        </CustomModal>
      )}
      {del && (
        <CustomModal title="Confirm Delete" onClose={CloseDeleteModal}>
          <h3>Are you sure to delete this item?</h3>
          <Stack
            direction="row"
            spacing={2}
            sx={{ justifyContent: "flex-end" }}
          >
            <CustomButtonComponent
              variant="outlined"
              color="primary"
              onClick={() => setDel(false)}
            >
              Cancel
            </CustomButtonComponent>
            <CustomButtonComponent
              variant="contained"
              color="error"
              onClick={confirmDelete}
            >
              Delete
            </CustomButtonComponent>
          </Stack>
        </CustomModal>
      )}
    </div>
  );
};
export default ActionIcons;
